import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

import axios from "axios";
import { useTranslation } from "react-i18next";
import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

import { Prompt } from "react-router-dom";

import { TextField, PrimaryButton, DefaultButton, Dropdown, Stack, getTheme, Icon, Toggle, Spinner, MessageBar, MessageBarType, Separator, Link } from "@fluentui/react";

import { UnifiedPeoplePicker } from '@fluentui/react-experiments/lib/UnifiedPeoplePicker';

var moment = require("moment"); // require
moment().locale("th");

const API_URL = process.env.REACT_APP_API_URL;

const theme = getTheme();

const stackTokens = { childrenGap: 10 };

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

const cardStyle = {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 30,
    background: "#ffffff",
    marginLeft: "0",
    marginTop: "10px",
    boxShadow: theme.effects.elevation4,
    width: 590,
};

function checkEmail(text) {
    const pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
  
    if (pattern.test(text)) return true
    return false
  }

// function getCurrentDate(numberObj) {
//     const { year, month, day } = numberObj

//     let _year = year ? moment().format(year) : ""
//     let _month = month ? moment().format(month) : ""
//     let _day = day ? moment().format(day) : ""

//     return _year + _month + _day !== "" ? moment().format(`${_year}${_month}${_day}`) : ""
// }

const ShopeeAutomation = () => {
    console.log("Re render");

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const { t } = useTranslation();

    const history = useHistory();

    const [buttonClick, setButtonClick] = useState(false);
    const [showMessageBarSuccess, setShowMessageBarSuccess] = useState(false);
    const [showMessageBarError, setShowMessageBarError] = useState(false);

    const [automationEnable, setAutomationEnable] = useState(false);
    const [triggerStatus, setTriggerStatus] = useState("COMPLETED");

    const [onlyBillingAddress, setOnlyBillingAddress] = useState(false);

    const [isChange, setIsChange] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [enableEmail, setEnableEmail] = useState(false)

    const orderStatusOptions = [
        { key: "COMPLETED", text: t("shopee.COMPLETED") },
        { key: "TO_CONFIRM_RECEIVE", text: t("shopee.ToConfirmReceive") },
        { key: "SHIPPED", text: t("shopee.SHIPPED") },
        { key: "READY_TO_SHIP", text: t("shopee.readyToSHIPPED") },
        { key: "PROCESSED", text: t("shopee.PROCESSED") },
        { key: "INVOICE_PENDING", text: t("shopee.InvoicePENDING") },
        { key: "UNPAID", text: t("shopee.UNPAID") },
        { key: "IN_CANCEL", text: t("shopee.InCANCEL") },
        { key: "CANCELLED", text: t("shopee.CANCELLED") },
    ];

    const yearFormatOptions = [
        { key: "YYYY", text: "YYYY" },
        { key: "YY", text: "YY" },
        { key: "", text: t("shopeeAutomation.none") },
    ];

    const monthFormatOptions = [
        { key: "MM", text: "MM" },
        { key: "", text: t("shopeeAutomation.none") },
    ];

    const dayFormatOptions = [
        { key: "DD", text: "DD" },
        { key: "", text: t("shopeeAutomation.none") },
    ];

    const [receiptTaxInvoice, setReceiptTaxInvoice] = useState({
        number: {
            prefix: "",
            year: "",
            month: "",
            day: "",
            suffix: "",
            originalSuffix: "",
            updatedTime: ""
        },
    });

    const [receiptTaxInvoiceAbb, setReceiptTaxInvoiceAbb] = useState({
        documentType: "RECEIPT-TAXINVOICE-ABB",
        number: {
            prefix: "",
            year: "",
            month: "",
            day: "",
            suffix: "",
            originalSuffix: "",
            updatedTime: ""
        },
        forceCreate: false,
    });

    const [sendEmail, setSendEmail] = useState(false);
    const [showShippingFee, setShowShippingFee] = useState(true);

    const [sendEmailOnlyBillingAddress, setSendEmailOnlyBillingAddress] = useState(false)

    const [cc, setCC] = useState([]);

    const [isChangeNumberReceiptTaxinvoice, setIsChangeNumberReceiptTaxinvoice] = useState(false)
    const [isChangeNumberReceiptTaxinvoiceAbb, setIsChangeNumberReceiptTaxinvoiceAbb] = useState(false)

    const companyId = sessionStorage.getItem('companyId') || '';

    async function handleSubmit(event) {
        event.preventDefault();

        setButtonClick(true);

        const _receiptTaxInvoice = {...receiptTaxInvoice}
        if (isChangeNumberReceiptTaxinvoice) {
            _receiptTaxInvoice.number.updatedTime = new Date().toISOString()
        }

        const _receiptTaxInvoiceAbb = {...receiptTaxInvoiceAbb}
        if (isChangeNumberReceiptTaxinvoiceAbb) {
            _receiptTaxInvoiceAbb.number.updatedTime = new Date().toISOString()
        }

        // console.log({
        //     enable: automationEnable,
        //     triggerStatus: triggerStatus,
        //     receiptTaxInvoice: _receiptTaxInvoice,
        //     receiptTaxInvoiceAbb: _receiptTaxInvoiceAbb,
        //     sendEmail: sendEmail,
        //     showShippingFee: showShippingFee,
        //     onlyBillingAddress: onlyBillingAddress,
        //     sendEmailOnlyBillingAddress: sendEmailOnlyBillingAddress,
        //     cc: cc.join(';')
        // });

        await instance
            .acquireTokenSilent({ ...silentRequest, account: account })
            .then(async (tokenResponse) => {
                axios
                    .patch(
                        API_URL + "/sources",
                        {
                            source: "shopee",
                            replace: "/automation",
                            value: {
                                enable: automationEnable,
                                triggerStatus: triggerStatus,
                                receiptTaxInvoice: _receiptTaxInvoice,
                                receiptTaxInvoiceAbb: _receiptTaxInvoiceAbb,
                                sendEmail: sendEmail,
                                showShippingFee: showShippingFee,
                                onlyBillingAddress: onlyBillingAddress,
                                sendEmailOnlyBillingAddress: sendEmailOnlyBillingAddress,
                                cc: cc.join(';')
                            },
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + tokenResponse.accessToken,
                                "cid": companyId
                            },
                        }
                    )
                    .then(
                        (response) => {
                            console.log("response", response);
                            setButtonClick(false);
                            setShowMessageBarSuccess(true);
                            setShowMessageBarError(false);

                            setIsChange(false);
                            window.scrollTo(0, 0);
                        },
                        (error) => {
                            console.log(error);
                            setButtonClick(false);
                            setShowMessageBarError(true);
                            window.scrollTo(0, 0);
                        }
                    );
            })
            .catch((error) => {
                //Acquire token silent failure, and send an interactive request
                console.log(error);
                instance.acquireTokenRedirect(silentRequest);
            });
    }

    useEffect(() => {
        console.log("userEffect initial call!");

        instance
            .acquireTokenSilent({ ...silentRequest, account: account })
            .then((tokenResponse) => {
                axios
                    .get(API_URL + "/sources/shopee", {
                        headers: {
                            Authorization: "Bearer " + tokenResponse.accessToken,
                            "cid": companyId
                        },
                    })
                    .then(
                        (response) => {
                            console.log("response", response);

                            if (response.data?.automation) {
                                const { enable: _enable, triggerStatus: _triggerStatus, receiptTaxInvoice: _receiptTaxInvoice, receiptTaxInvoiceAbb: _receiptTaxInvoiceAbb, sendEmail: _sendEmail, showShippingFee: _showShippingFee, onlyBillingAddress: _onlyBillingAddress, sendEmailOnlyBillingAddress: _sendEmailOnlyBillingAddress, cc: _cc } = response.data.automation;

                                setAutomationEnable(_enable);
                                setTriggerStatus(_triggerStatus);
                                setReceiptTaxInvoice(_receiptTaxInvoice);
                                setReceiptTaxInvoiceAbb(_receiptTaxInvoiceAbb);
                                setSendEmail(_sendEmail);
                                setShowShippingFee(_showShippingFee);
                                setOnlyBillingAddress(_onlyBillingAddress);
                                setSendEmailOnlyBillingAddress(_sendEmailOnlyBillingAddress)
                                if (_cc) {
                                    setCC(_cc.split(";"))
                                }
                            }

                            setIsLoading(false);
                        },
                        (error) => {
                            console.log(error);

                            setIsLoading(false);
                        }
                    );
            })
            .catch((error) => {
                //Acquire token silent failure, and send an interactive request
                console.log(error);
                instance.acquireTokenRedirect(silentRequest);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function ExampleNumberRCT(props) {
        const { numberObj } = props;
        const result = numberObj.number.prefix || numberObj.number.year || numberObj.number.month || numberObj.number.day || numberObj.number.suffix;
        const year = numberObj.number.year ? moment().format(`${numberObj.number.year}`) : "";
        const month = numberObj.number.month ? moment().format(`${numberObj.number.month}`) : "";
        const day = numberObj.number.day ? moment().format(`${numberObj.number.day}`) : "";

        if (result)
            return (
                <Stack horizontal horizontalAlign="center" styles={{ root: { height: 55 } }}>
                    <h3>
                        {t("shopeeAutomation.example")} {numberObj.number.prefix + year + month + day + numberObj.number.suffix}
                    </h3>
                </Stack>
            );

        return <Stack horizontal horizontalAlign="center" styles={{ root: { height: 55 } }}></Stack>;
    }

    function CustomPrompt(props) {
        const { when } = props;

        return <Prompt when={when} message={() => t("shopeeAutomation.unSavedMessage")} />;
    }

    function CustomVariantTextField(props) {
        return (
            <div style={{ width: 436}}>
                <UnifiedPeoplePicker
                    selectedItemsListProps={{
                        selectedItems: [...cc.map(_email => (
                            { key: _email, text: _email }
                        ))],
                        removeButtonAriaLabel: 'Remove',
                        onItemsRemoved: (removeItems, removeItemIndex) => {
                            const currentSelectedItemsCopy = [...cc];
                            currentSelectedItemsCopy.splice(removeItemIndex, 1);
                            // this.setState({ currentSelectedItems: [...currentSelectedItemsCopy] });
                            setCC([...currentSelectedItemsCopy])
    
                            setIsChange(true);
                            
                        },
                    }}
                    floatingSuggestionProps={{
                        isSuggestionsVisible: false
                    }}
                    inputProps={{
                        'aria-label': 'Add people',
                    }}
                    onBlur={(e) => {
                        if (checkEmail(e.target.value) && !cc.includes(e.target.value)) {
                            const currentSelectedItemsCopy = [...cc, e.target.value];
            
                            setCC(currentSelectedItemsCopy)
    
                            setIsChange(true);
                        }
                        
                    }} 
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            if (checkEmail(e.target.value) && !cc.includes(e.target.value)) {
                                const currentSelectedItemsCopy = [...cc, e.target.value];
            
                                setCC(currentSelectedItemsCopy)
    
                                setIsChange(true);
                            }
                        }
                    }} 
                    // eslint-disable-next-line react/jsx-no-bind
                    customClipboardType="recipients"
                />
            </div>
        );
      }

    const handleCancel = (e) => {
        history.push({
            pathname: "/etax/sources/shopee",
            state: {},
        });
    };

    useEffect(() => {
        instance
            .acquireTokenSilent({ ...silentRequest, account: account })
                .then((tokenResponse) => {
                    axios
                        .get(API_URL + '/sources/emails', {
                            headers: {
                                Authorization: 'Bearer ' + tokenResponse.accessToken,
                                "cid": companyId
                            },
                        })
                        .then(
                            (response) => {
                                console.log('Email sources: ', response);

                                if (response.data) {
                                    if (!response.data.disabled) {
                                        setEnableEmail(true);
                                    }
                                }
                            },
                            (error) => {
                                console.log(error);
                            }
                        );
                    })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      console.log('currentDate rct', receiptTaxInvoice.number.updatedTime)
    }, [receiptTaxInvoice])
    
    useEffect(() => {
        console.log('currentDate abb', receiptTaxInvoiceAbb.number.updatedTime)
      }, [receiptTaxInvoiceAbb])

    return (
        <>
            <div style={homeStyles}>
                <CustomPrompt when={isChange} />
                {showMessageBarSuccess && (
                    <MessageBar messageBarType={MessageBarType.success} isMultiline={false} onDismiss={() => setShowMessageBarSuccess(false)} dismissButtonAriaLabel="Close">
                        {t("company.updateSuccess")}
                    </MessageBar>
                )}
                {showMessageBarError && (
                    <MessageBar messageBarType={MessageBarType.error} isMultiline={false} onDismiss={() => setShowMessageBarError(false)} dismissButtonAriaLabel="Close">
                        {t("company.updateFail")}
                    </MessageBar>
                )}
                <Stack horizontal horizontalAlign="center">
                    <Stack style={{ background: "#FAF9F8" }}>
                        <form onSubmit={handleSubmit} onKeyDown={(e) => {
                            if (e.key == "Enter") {
                                e.preventDefault();
                            }
                        }}>
                            <Stack horizontal horizontalAlign="space-between">
                                <Stack verticalAlign="center">
                                    <Stack horizontal>
                                        <h1>
                                            <Icon iconName="Robot" style={{ color: "#106ebe" }} /> Shopee Automation
                                        </h1>
                                    </Stack>
                                </Stack>
                                <Stack verticalAlign="center" styles={{ root: { marginTop: 7 } }}>
                                    <Toggle
                                        styles={{ root: { width: 80 } }}
                                        onText={t("company.on")}
                                        offText={t("company.off")}
                                        checked={automationEnable}
                                        onChange={(e, checked) => {
                                            setIsChange(true);
                                            setAutomationEnable(checked);
                                        }}
                                        disabled={isLoading}
                                    />
                                </Stack>
                            </Stack>
                            <div style={cardStyle}>
                                <Stack horizontal horizontalAlign="space-between">
                                    <Stack verticalAlign="center" styles={{ root: { marginTop: 10 } }}>
                                        <Stack horizontal>
                                            <h2>
                                                <Icon iconName="Sync" style={{ color: "#106ebe", marginTop: "3px", marginRight: "7px" }} />
                                            </h2>{" "}
                                            <h2>{t("shopeeAutomation.triggerStatus")}</h2>
                                        </Stack>
                                    </Stack>

                                    <Stack verticalAlign="center">
                                        <Dropdown
                                            label={t("shopeeAutomation.orderStatus")}
                                            styles={{ root: { width: 150, marginTop: -15 } }}
                                            options={orderStatusOptions}
                                            selectedKey={triggerStatus}
                                            onChange={(e, selectedOption) => {
                                                setIsChange(true);
                                                setTriggerStatus(selectedOption.key);
                                            }}
                                            disabled={!automationEnable}
                                        />
                                    </Stack>
                                </Stack>
                                <br />

                                <div>
                                    <Separator />
                                </div>
                                <br />

                                <Stack horizontal>
                                    <h2>
                                        <Icon iconName="TextDocument" style={{ color: "#106ebe", marginRight: "7px" }} />
                                    </h2>{" "}
                                    <h3>{t("shopeeAutomation.receiptTaxInvoice")}</h3>
                                </Stack>

                                <Stack horizontal horizontalAlign="space-between">
                                    <Stack verticalAlign="center" styles={{ root: { marginTop: 10 } }}>
                                        <h3>{t("shopeeAutomation.number")}</h3>
                                    </Stack>
                                    <Stack verticalAlign="center">
                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                            <TextField
                                                label={t("shopeeAutomation.prefix")}
                                                styles={{ root: { width: 120, marginTop: -15 } }}
                                                value={receiptTaxInvoice.number.prefix}
                                                onChange={(e, newValue) => {
                                                    setIsChange(true);
                                                    setIsChangeNumberReceiptTaxinvoice(true)
                                                    setReceiptTaxInvoice((prev) => ({ number: { ...prev.number, prefix: newValue } }));
                                                }}
                                                disabled={!automationEnable}
                                            />
                                            <Dropdown
                                                label={t("shopeeAutomation.year")}
                                                styles={{ root: { width: 75, marginTop: -15 } }}
                                                options={yearFormatOptions}
                                                selectedKey={receiptTaxInvoice.number.year}
                                                onChange={(e, selectedOption) => {
                                                    setIsChange(true);
                                                    setIsChangeNumberReceiptTaxinvoice(true)
                                                    setReceiptTaxInvoice((prev) => ({ number: { ...prev.number, year: selectedOption.key } }));
                                                }}
                                                disabled={!automationEnable}
                                            />
                                            <Dropdown
                                                label={t("shopeeAutomation.month")}
                                                styles={{ root: { width: 70, marginTop: -15 } }}
                                                options={monthFormatOptions}
                                                selectedKey={receiptTaxInvoice.number.month}
                                                onChange={(e, selectedOption) => {
                                                    setIsChange(true);
                                                    setIsChangeNumberReceiptTaxinvoice(true)
                                                    setReceiptTaxInvoice((prev) => ({ number: { ...prev.number, month: selectedOption.key } }));
                                                }}
                                                disabled={!automationEnable}
                                            />
                                            <Dropdown
                                                label={t("shopeeAutomation.day")}
                                                styles={{ root: { width: 70, marginTop: -15 } }}
                                                options={dayFormatOptions}
                                                selectedKey={receiptTaxInvoice.number.day}
                                                onChange={(e, selectedOption) => {
                                                    setIsChange(true);
                                                    setIsChangeNumberReceiptTaxinvoice(true)
                                                    setReceiptTaxInvoice((prev) => ({ number: { ...prev.number, day: selectedOption.key } }));
                                                }}
                                                disabled={!automationEnable}
                                            />
                                            <TextField
                                                label={t("shopeeAutomation.suffix")}
                                                styles={{ root: { width: 150, marginTop: -15 } }}
                                                value={receiptTaxInvoice.number.suffix}
                                                onChange={(e, newValue) => {
                                                    if (!/\D/.test(newValue)) {
                                                        setIsChange(true);
                                                        setIsChangeNumberReceiptTaxinvoice(true)
                                                        setReceiptTaxInvoice((prev) => ({ number: { ...prev.number, suffix: newValue, originalSuffix: newValue } }));
                                                    }
                                                }}
                                                required={automationEnable}
                                                disabled={!automationEnable}
                                            />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <ExampleNumberRCT numberObj={receiptTaxInvoice} />
                                <br />

                                <div>
                                    <Separator />
                                </div>

                                <br />
                                <Stack horizontal horizontalAlign="space-between">
                                    <Stack vertical>
                                        <Stack horizontal>
                                            <h2>
                                                <Icon iconName="AutoFillTemplate" style={{ color: "#106ebe", marginRight: "7px" }} />
                                            </h2>{" "}
                                            <h3 style={{ marginTop: "18px" }}>{t("shopeeAutomation.createOnlyBillingAddress")}</h3>
                                        </Stack>
                                        <span>
                                            <b>{t("shopeeAutomation.on")}</b> {t("shopeeAutomation.onCreateOnlyBillingAddressNote")}
                                        </span>
                                        <br />
                                        <span>
                                            <b>{t("shopeeAutomation.off")}</b> {t("shopeeAutomation.offCreateOnlyBillingAddressNote")}
                                        </span>
                                    </Stack>
                                    <Stack verticalAlign="start" styles={{ root: { marginTop: 17 } }}>
                                        <Toggle
                                            styles={{ root: { width: 80 } }}
                                            onText={t("company.on")}
                                            offText={t("company.off")}
                                            checked={onlyBillingAddress}
                                            onChange={(e, checked) => {
                                                setIsChange(true);
                                                setOnlyBillingAddress(checked);
                                            }}
                                            disabled={!automationEnable}
                                        />
                                    </Stack>
                                </Stack>
                                <br />

                                <div>
                                    <Separator />
                                </div>

                                <br />
                                <Stack horizontal horizontalAlign="space-between">
                                    {/* {i18n.language === "th" ? <h4>{t("shopeeAutomation.forceCreate")}</h4> : <h4>{t("shopeeAutomation.forceCreate")}</h4>} */}
                                    <Stack horizontal>
                                        <h2>
                                            <Icon iconName="M365InvoicingLogo" style={{ color: "#106ebe", marginRight: "7px" }} />
                                        </h2>{" "}
                                        <h4>{t("shopeeAutomation.forceCreate")}</h4>
                                    </Stack>
                                    <Stack verticalAlign="center" styles={{ root: { marginTop: 7 } }}>
                                        <Toggle
                                            styles={{ root: { width: 80 } }}
                                            onText={t("company.on")}
                                            offText={t("company.off")}
                                            checked={receiptTaxInvoiceAbb.forceCreate}
                                            onChange={(e, checked) => {
                                                setIsChange(true);
                                                setReceiptTaxInvoiceAbb((prev) => ({ ...prev, forceCreate: checked }));
                                            }}
                                            disabled={!automationEnable}
                                        />
                                    </Stack>
                                </Stack>
                                {receiptTaxInvoiceAbb.forceCreate ? (
                                    <>
                                        <Stack horizontal>
                                            <h2>
                                                <Icon iconName="TextDocument" style={{ color: "#106ebe", marginRight: "7px" }} />
                                            </h2>{" "}
                                            <h3>{t("shopeeAutomation.receiptTaxInvoiceAbb")}</h3>
                                        </Stack>
                                        <Stack horizontal horizontalAlign="space-between">
                                            <Stack verticalAlign="center" styles={{ root: { marginTop: 10 } }}>
                                                <h3>{t("shopeeAutomation.number")}</h3>
                                            </Stack>
                                            <Stack verticalAlign="center">
                                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                    <TextField
                                                        label={t("shopeeAutomation.prefix")}
                                                        styles={{ root: { width: 120, marginTop: -15 } }}
                                                        value={receiptTaxInvoiceAbb.number.prefix}
                                                        onChange={(e, newValue) => {
                                                            setIsChange(true);
                                                            setIsChangeNumberReceiptTaxinvoiceAbb(true)
                                                            setReceiptTaxInvoiceAbb((prev) => ({ ...prev, number: { ...prev.number, prefix: newValue } }));
                                                        }}
                                                        disabled={!automationEnable || !receiptTaxInvoiceAbb.forceCreate}
                                                    />
                                                    <Dropdown
                                                        label={t("shopeeAutomation.year")}
                                                        styles={{ root: { width: 75, marginTop: -15 } }}
                                                        options={yearFormatOptions}
                                                        selectedKey={receiptTaxInvoiceAbb.number.year}
                                                        onChange={(e, selectedOption) => {
                                                            setIsChange(true);
                                                            setIsChangeNumberReceiptTaxinvoiceAbb(true)
                                                            setReceiptTaxInvoiceAbb((prev) => ({ ...prev, number: { ...prev.number, year: selectedOption.key } }));
                                                        }}
                                                        disabled={!automationEnable || !receiptTaxInvoiceAbb.forceCreate}
                                                    />
                                                    <Dropdown
                                                        label={t("shopeeAutomation.month")}
                                                        styles={{ root: { width: 70, marginTop: -15 } }}
                                                        options={monthFormatOptions}
                                                        selectedKey={receiptTaxInvoiceAbb.number.month}
                                                        onChange={(e, selectedOption) => {
                                                            setIsChange(true);
                                                            setIsChangeNumberReceiptTaxinvoiceAbb(true)
                                                            setReceiptTaxInvoiceAbb((prev) => ({ ...prev, number: { ...prev.number, month: selectedOption.key } }));
                                                        }}
                                                        disabled={!automationEnable || !receiptTaxInvoiceAbb.forceCreate}
                                                    />
                                                    <Dropdown
                                                        label={t("shopeeAutomation.day")}
                                                        styles={{ root: { width: 70, marginTop: -15 } }}
                                                        options={dayFormatOptions}
                                                        selectedKey={receiptTaxInvoiceAbb.number.day}
                                                        onChange={(e, selectedOption) => {
                                                            setIsChange(true);
                                                            setIsChangeNumberReceiptTaxinvoiceAbb(true)
                                                            setReceiptTaxInvoiceAbb((prev) => ({ ...prev, number: { ...prev.number, day: selectedOption.key } }));
                                                        }}
                                                        disabled={!automationEnable || !receiptTaxInvoiceAbb.forceCreate}
                                                    />
                                                    <TextField
                                                        label={t("shopeeAutomation.suffix")}
                                                        styles={{ root: { width: 150, marginTop: -15 } }}
                                                        value={receiptTaxInvoiceAbb.number.suffix}
                                                        onChange={(e, newValue) => {
                                                            if (!/\D/.test(newValue)) {
                                                                setIsChange(true);
                                                                setIsChangeNumberReceiptTaxinvoiceAbb(true)
                                                                setReceiptTaxInvoiceAbb((prev) => ({ ...prev, number: { ...prev.number, suffix: newValue, originalSuffix: newValue } }));
                                                            }
                                                        }}
                                                        required={receiptTaxInvoiceAbb.forceCreate}
                                                        disabled={!automationEnable || !receiptTaxInvoiceAbb.forceCreate}
                                                    />
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                        <ExampleNumberRCT numberObj={receiptTaxInvoiceAbb} />
                                    </>
                                ) : null}
                                <br />

                                <div>
                                    <Separator />
                                </div>

                                <br />
                                <Stack horizontal horizontalAlign="space-between">
                                    <Stack horizontal>
                                        <h2>
                                            <Icon iconName="DeliveryTruck" style={{ color: "#106ebe", marginRight: "7px" }} />
                                        </h2>{" "}
                                        <h3 style={{ marginTop: "17px" }}>{t("shopeeAutomation.showShippingFee")}</h3>
                                    </Stack>
                                    <Stack verticalAlign="center" styles={{ root: { marginTop: 7 } }}>
                                        <Toggle
                                            styles={{ root: { width: 80 } }}
                                            onText={t("company.on")}
                                            offText={t("company.off")}
                                            checked={showShippingFee}
                                            onChange={(e, checked) => {
                                                setIsChange(true);
                                                setShowShippingFee(checked);
                                            }}
                                            disabled={!automationEnable}
                                        />
                                    </Stack>
                                </Stack>
                                <br />

                                <div>
                                    <Separator />
                                </div>

                                <br />
                                <Stack horizontal horizontalAlign="space-between">
                                    <Stack vertical>
                                        <Stack horizontal>
                                            <h2>
                                                <Icon iconName="MailForward" style={{ color: "#106ebe", marginRight: "7px" }} />
                                            </h2>{" "}
                                            <h3 style={{ marginTop: "18px" }}>{t("shopeeAutomation.autoSendEmail")}</h3>
                                        </Stack>
                                        {/* <Stack horizontal>
                                            <span>{t("shopeeAutomation.autoSendEmailNote")}</span>
                                        </Stack>
                                        <br /> */}
                                        {enableEmail && (
                                            <Stack>
                                                <span>{t("shopeeAutomation.autoSendEmailNote")}</span>
                                        <br />

                                                <span>
                                                    <b>{t("shopeeAutomation.on")}</b> {t("shopeeAutomation.onAutoSendEmail")}
                                                </span>
                                                <br />
                                                <span>
                                                    <b>{t("shopeeAutomation.off")}</b> {t("shopeeAutomation.offAutoSendEmail")}
                                                </span>
                                                <br />
                                            </Stack>
                                        )}
                                    </Stack>
                                    <Stack verticalAlign="start" styles={{ root: { marginTop: 17 } }}>
                                    {enableEmail ? (
                                        <Toggle
                                            styles={{ root: { width: 80 } }}
                                            onText={t("company.on")}
                                            offText={t("company.off")}
                                            checked={sendEmail}
                                            onChange={(e, checked) => {
                                                setIsChange(true);
                                                setSendEmail(checked);
                                                setSendEmailOnlyBillingAddress(checked)
                                            }}
                                            disabled={!automationEnable}
                                        />
                                        ) : (
                                            <Link
                                                styles={{ root: { marginTop: -7}}}
                                                onClick={() => {
                                                    history.push({
                                                        pathname: "/settings/emails",
                                                        state: {},
                                                    });
                                                }}
                                                disabled={!automationEnable}
                                            >
                                                <span style={{ margin: "0px 10px"}}>{t("shopeeAutomation.emailSetting")}</span>
                                            </Link>
                                        )}
                                    </Stack>
                                </Stack>
                                {sendEmail ? (
                                    <>
                                        <Stack horizontal horizontalAlign="space-between">
                                            <Stack horizontal>
                                                <h2>
                                                    <Icon iconName="MailForward" style={{ color: "#106ebe", marginRight: "7px" }} />
                                                </h2>{" "}
                                                <h3 style={{ marginTop: "18px" }}>{t("shopeeAutomation.sendEmailOnlyBillingAddress")}</h3>
                                            </Stack>

                                            <Stack verticalAlign="center" styles={{ root: { marginTop: 7 } }}>
                                                <Toggle
                                                    styles={{ root: { width: 80 } }}
                                                    onText={t("company.on")}
                                                    offText={t("company.off")}
                                                    checked={sendEmailOnlyBillingAddress}
                                                    onChange={(e, checked) => {
                                                        setIsChange(true);
                                                        setSendEmailOnlyBillingAddress(checked);
                                                    }}
                                                    disabled={!automationEnable}
                                                />
                                            </Stack>
                                        </Stack>
                                        <Stack horizontal>
                                            <Stack styles={{ root: { width: '30%' } }}>
                                                <h3>{t("shopeeAutomation.cc")}</h3>
                                            </Stack>
                                            <CustomVariantTextField />
                                        </Stack>
                                    </>
                                ) : null}
                            </div>

                            <br />
                            <br />
                            <Separator>{t("company.saveSeparator")}</Separator>
                            <br />
                            <br />

                            <Stack horizontal horizontalAlign="center" tokens={stackTokens}>
                                {!buttonClick && <PrimaryButton name="save" text={t("company.save")} iconProps={{ iconName: "Save" }} type="submit" style={{ width: "125px", letterSpacing: "1px" }} />}
                                {!buttonClick && <DefaultButton name="back" text={t("company.back")} type="button" onClick={handleCancel} />}

                                {buttonClick && <Spinner label={t("company.saving")} labelPosition="right" />}
                            </Stack>
                        </form>
                    </Stack>
                </Stack>
            </div>
        </>
    );
};

export default ShopeeAutomation;
